// activityNewUser3
export default {
  routerTitle: '新客戶三獎賞',
  giftPackage: '禮包',
  shareTitle: '新客戶三重獎賞(新年福利）',
  shareDesc: '最高享價值3800HKD大禮包，認購投資組合享高達500HKD！ ',

  cardOneTitle: '註冊就送88HKD禮包',
  cardOneText: '30天美股LV1行情券',

  cardTwoTitle: '開戶就送2256HKD禮包',
  cardTwoText1: '180天港股LV2',
  cardTwoText2: '180天美股LV1',

  cardThreeTitle: '入金2W最高贈送',
  cardThreeTabelTitle: '首筆入金≥2萬HKD',
  cardThreeTabelRow1Left1: '30天內無出金記錄',
  cardThreeTabelRow1Left2: '且30天內交易一次',
  cardThreeTabelRow1Right1: '滿足條件就送',
  cardThreeTabelRow1Right2: '300HKD',
  cardThreeTabelRow1Right3: '現金券',
  cardThreeTabelRow2Left1: '開通投資組合帳戶',
  cardThreeTabelRow2Right1: '送',
  cardThreeTabelRow2Right2: '福特(NYSE：F)-2股',

  cardFourTitle: '入金30W最高贈送',
  cardFourTabelTitle: '首筆入金≥30萬HKD',
  cardFourTabelRow1Left1: '30天內無出金紀錄',
  cardFourTabelRow1Left2: '且30天內交易一次',
  cardFourTabelRow1Right1: '滿足條件就送',
  cardFourTabelRow1Right2: '1300HKD',
  cardFourTabelRow1Right3: '現金券',
  cardFourTabelRow2Left1: '開通投資組合帳戶',
  cardFourTabelRow2Right1: '送',
  cardFourTabelRow2Right2: '福特(NYSE：F)-2股',

  cardFiveTitle: '首次認購盈寶投資組合專屬',
  cardFiveTabelTitle: '首次認購≥1000USD',
  cardFiveTabelRow1Left1: '連續持有滿30天',
  cardFiveTabelRow1Left2: '且無轉出資金',
  cardFiveTabelRow1Right1: '滿足條件就送',
  cardFiveTabelRow1Right2: '300HKD',
  cardFiveTabelRow1Right3: '現金券',

  pageTips: '註：首筆入金2萬獎勵和首筆入金30萬獎勵只能參與一個'
}
